'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./../../../libs/utils');

var _RenderIf = require('./../../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _label = require('./label');

var _label2 = _interopRequireDefault(_label);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var InputRadio = function (_Component) {
  _inherits(InputRadio, _Component);

  function InputRadio(props) {
    _classCallCheck(this, InputRadio);

    var _this = _possibleConstructorReturn(this, (InputRadio.__proto__ || Object.getPrototypeOf(InputRadio)).call(this, props));

    _this.inputId = (0, _utils.uniqueId)('input-radio');
    _this.inlineTextLabelId = (0, _utils.uniqueId)('inline-text-label');
    _this.errorMessageId = (0, _utils.uniqueId)('error-message');
    _this.inputRef = _react2.default.createRef();
    return _this;
  }

  _createClass(InputRadio, [{
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var _props = this.props,
          className = _props.className,
          error = _props.error;
      return (0, _classnames2.default)('rainbow-input-radio_container', {
        'rainbow-input-radio--error': error
      }, className);
    }
  }, {
    key: 'getInlineTextLabelId',
    value: function getInlineTextLabelId() {
      var bottomHelpText = this.props.bottomHelpText;

      if (bottomHelpText) {
        return this.inlineTextLabelId;
      }

      return undefined;
    }
  }, {
    key: 'getErrorMessageId',
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorMessageId;
      }

      return undefined;
    }
    /**
     * Sets focus on the element.
     * @public
     */

  }, {
    key: 'focus',
    value: function focus() {
      this.inputRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: 'click',
    value: function click() {
      this.inputRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: 'blur',
    value: function blur() {
      this.inputRef.current.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          value = _props2.value,
          onChange = _props2.onChange,
          label = _props2.label,
          error = _props2.error,
          disabled = _props2.disabled,
          tabIndex = _props2.tabIndex,
          onFocus = _props2.onFocus,
          onBlur = _props2.onBlur,
          onClick = _props2.onClick,
          onKeyDown = _props2.onKeyDown,
          bottomHelpText = _props2.bottomHelpText,
          id = _props2.id,
          name = _props2.name,
          checked = _props2.checked,
          hideLabel = _props2.hideLabel;
      return _react2.default.createElement('div', {
        id: id,
        className: this.getContainerClassNames(),
        style: style
      }, _react2.default.createElement('span', {
        className: 'rainbow-input-radio_inner-container'
      }, _react2.default.createElement('input', {
        id: this.inputId,
        name: name,
        type: 'radio',
        value: value,
        onChange: onChange,
        tabIndex: tabIndex,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        onKeyDown: onKeyDown,
        disabled: disabled,
        checked: checked,
        'aria-labelledby': this.getInlineTextLabelId(),
        'aria-describedby': this.getErrorMessageId(),
        ref: this.inputRef
      }), _react2.default.createElement(_label2.default, {
        disabled: disabled,
        label: label,
        hideLabel: hideLabel,
        inputId: this.inputId,
        id: this.getInlineTextLabelId()
      })), _react2.default.createElement(_RenderIf2.default, {
        isTrue: !!bottomHelpText
      }, _react2.default.createElement('div', {
        className: 'rainbow-input-radio_help'
      }, bottomHelpText)), _react2.default.createElement(_RenderIf2.default, {
        isTrue: !!error
      }, _react2.default.createElement('div', {
        id: this.getErrorMessageId(),
        className: 'rainbow-input-radio_error-message'
      }, error)));
    }
  }]);

  return InputRadio;
}(_react.Component);

exports.default = InputRadio;
InputRadio.propTypes = {
  value: _propTypes2.default.string,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  name: _propTypes2.default.string,
  bottomHelpText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  checked: _propTypes2.default.bool,
  hideLabel: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  id: _propTypes2.default.string
};
InputRadio.defaultProps = {
  value: undefined,
  name: undefined,
  bottomHelpText: null,
  error: null,
  disabled: false,
  onChange: function onChange() {},
  tabIndex: undefined,
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onKeyDown: function onKeyDown() {},
  checked: undefined,
  hideLabel: false,
  className: undefined,
  style: undefined,
  id: undefined
};